import {
  DATE,
  LEFT,
  TEXT,
  UP,
} from "../../../../components/organisms/TemplateBuilder/TemplateItemEditor/FormatEditor/constants";

import {
  AttributeFormat,
  BaseNumberFormat,
  ColumnFormat,
  DateFormat,
  FileFormat,
  GeneralValueFormat,
  NumberFormat,
  SelectFormat,
  TextFormat,
  TypeSpecificValueFormat,
  ValueFormat,
} from "../columnFormat";

export const dateFormatPLACEHOLDER: DateFormat = {
  variant: DATE,
};

export const textFormatPLACEHOLDER: TextFormat = {
  asTextArea: false,
  asPhoneOrMail: false,
};

export const numberFormatPLACEHOLDER: Required<BaseNumberFormat> &
  NumberFormat = {
  divisor: 1,
  roundTo: 1,
  roundingDirection: UP,
  unit: "",
  thousandsSeparator: " ",
};

export const selectFormatPLACEHOLDER: SelectFormat = {
  displayAsSearchSelect: false,
};

export const fileFormatPLACEHOLDER: FileFormat = {
  fileSize: 0,
  allowedFileTypes: [],
  hegFileRelation: null,
  hegFileFolder: null,
  hegSubjectNumberColumn: null,

  dbFileTableId: null,
  dbFileContentColumnName: null,
  dbFileNameColumnName: null,
  dbFileUniqueKeyColumnName: null,
  dbFileUniqueKeyType: "key",
  dbFileContentFormat: "byteArray",
  dbFileAggGroupColumnId: null,
};

export const attributeFormatPLACEHOLDER: AttributeFormat = {
  textAlign: LEFT,
  icon: "",
  variant: TEXT,
  showOnMobile: true,
  mobileVariant: TEXT,
  x: 0,
  y: 0,
};

export const generalValueFormatPLACEHOLDER: GeneralValueFormat = {
  textAlign: LEFT,
  iconOptions: [],
  colorOptions: [],
  required: true,
};

export const typeSpecificValueFormatPLACEHOLDER: TypeSpecificValueFormat = {
  number: null,
  date: null,
  text: null,
  file: null,
  select: null,
};

export const valueFormatPLACEHOLDER: ValueFormat = {
  general: generalValueFormatPLACEHOLDER,
  typeSpecific: typeSpecificValueFormatPLACEHOLDER,
  x: 0,
  y: 0,
};

export const columnFormatPLACEHOLDER: ColumnFormat = {
  label: attributeFormatPLACEHOLDER,
  value: valueFormatPLACEHOLDER,
};
